/**
 * おすすめ特集：.js-special-card-body を行ごとに高さ揃え（jquery-match-height）
 */
import $ from 'jquery';
import 'jquery-match-height';

function debounce(fn, ms) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(null, args), ms);
	};
}

export function initSpecialCardBodyMatchHeight() {
	const root = document.querySelector('.special');
	if (!root) return;

	const $bodies = $(root).find('.js-special-card-body');
	if (!$bodies.length) return;

	const update = () => {
		$bodies.matchHeight('remove');
		// PC は 3 列グリッドで同一行を揃える。SP は 1 列のため実質 1 要素ずつの行になる
		$bodies.matchHeight({ byRow: true });
	};

	update();

	const onResize = debounce(update, 150);
	window.addEventListener('resize', onResize);

	if (document.fonts?.ready) {
		document.fonts.ready.then(update);
	}

	const list = root.querySelector('.special__list');
	if (list && typeof ResizeObserver !== 'undefined') {
		const ro = new ResizeObserver(debounce(update, 100));
		ro.observe(list);
	}
}
